export default "__VITE_ASSET__DpGxZtJl__"